import React, {Component, PropTypes} from 'react'
import moment from 'moment'
import cx from 'classnames'
import {Row, Col} from 'react-bootstrap'
import extract from '../../core/extract'
import config from '../../config'
import Card from '../../core/components/Card'
import Icon from '../../core/components/Icon'
import i18n from '../i18n'
import style from './ReportCard.less'

class ReportCard extends Component {
    static propTypes = {
        report: PropTypes.object.isRequired
    }

    _openPdfWindow(event) {
        const {report} = this.props

        event.stopPropagation()
        event.preventDefault()
        window.open(config.audit.url + '/api/audits/' + report.uid + '.pdf')
    }

    render() {
        const {report, ...others} = this.props

        const header = (
            <h5>audit <small>{moment(report.updated).format(i18n.dateFormat.default)}</small></h5>
        )

        return (
            <div className={style.default}>
                <Card justified
                    kind='tab'
                    header={header}
                    {...others}>
                    <Row className='no-gutter'>
                        <Col xs={6}>
                            <div className={style.score}>
                                <h5>> {i18n.score} : <small>{report.score * 100} %</small></h5>
                            </div>
                        </Col>
                        <Col xs={6}>
                            <div className={style.pdf}>
                                <a
                                    href=''
                                    onClick={(e) => this._openPdfWindow(e)}>
                                    <Icon icon='pdf' size='sm' />
                                </a>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </div>
        )
    }
}

export default ReportCard


// WEBPACK FOOTER //
// ./lib/audit/components/ReportCard.js